import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Dropdown } from '../ButtonWithDropdown/ButtonWithDropdown';
import { getQTipData } from '../Tooltip/qTip.utilities';
import type { QTipDataAttributes } from '../Tooltip/QTip.types';
import type { TriggerWithDropdownProps } from './TriggerWithDropdown.types';

const disabledClasses = ['tw:opacity-50', 'tw:cursor-not-allowed'].join(' ');

const TriggerWithDropdown = (props: TriggerWithDropdownProps) => {
  const { triggerIcon, id, extraClassNames = '', disabled = false, ...tooltipProps } = props;

  const tooltipData: QTipDataAttributes | undefined = getQTipData(tooltipProps);

  return (
    <Dropdown {...props}>
      <DropdownMenu.Trigger
        id={id}
        className="tw:bg-transparent tw:border-none tw:focus-visible:outline-none tw:focus:outline-none tw:focus-within:outline-none"
        disabled={disabled}>
        <div
          {...tooltipData}
          className={`tw:bg-transparent tw:flex tw:flex-col tw:items-center tw:focus-visible:outline-none tw:focus:outline-none tw:focus-within:outline-none ${
            disabled ? disabledClasses : ''
          } ${extraClassNames}`}>
          {triggerIcon}
        </div>
      </DropdownMenu.Trigger>
    </Dropdown>
  );
};

export default TriggerWithDropdown;
